import { render } from "./BaseTextInput.vue?vue&type=template&id=c53b35a8&scoped=true"
import script from "./BaseTextInput.vue?vue&type=script&lang=js"
export * from "./BaseTextInput.vue?vue&type=script&lang=js"

import "./BaseTextInput.vue?vue&type=style&index=0&id=c53b35a8&scoped=true&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53b35a8"]])

export default __exports__